import {Component, OnDestroy} from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { takeWhile } from 'rxjs/operators' ;
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-country-content',
  styleUrls: ['./country-content.component.scss'],
  templateUrl: './country-content.component.html',
})
export class CountryContentComponent implements OnDestroy {

  private alive = true;
  countryName: string = '';
  countryType: string= '';

  constructor(private themeService: NbThemeService,
              private route: Router) {
    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
    });

    this.countryType = this.route.getCurrentNavigation().extras.state.countryType;
    this.countryName = this.route.getCurrentNavigation().extras.state.countryName;

    console.log("Country Content information", this.countryType, ' / ', this.countryName); // should log out 'bar'
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
